import { render } from "./SFWGalleryView.vue?vue&type=template&id=991934a4"
import script from "./SFWGalleryView.vue?vue&type=script&lang=js"
export * from "./SFWGalleryView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__